module.exports = __webpack_public_path__ + "static/MAMSB-115ac3dd6686ca4daff98052e86ab944.jpg";